import React from "react";
import { Modal, ModalHeader, ModalBody, Button, Table, Alert } from "reactstrap";
import axios from "axios";
import { API_URL_SEDE_SUBCATS } from "../../constants";
import NewSubcategoryForm from "./NewSubcategoryForm";
import { getAuthHeaders } from "../../utils/auth";

export default class ManageSedeSubcatsModal extends React.Component {
  state = {
    open: false,
    loading: false,
    error: "",
    subcats: [],
    deletingId: null,
  };

  toggle = () => {
    this.setState(
      (prev) => ({ open: !prev.open, error: "" }),
      () => {
        if (this.state.open) this.fetchSubcats();
      }
    );
  };

  fetchSubcats = async () => {
    const { sede } = this.props;
    const sedeId = sede?.pk ?? sede?.id;
    if (!sedeId) return;
    this.setState({ loading: true, error: "" });
    try {
      const headers = getAuthHeaders();
      const { data } = await axios.get(`${API_URL_SEDE_SUBCATS}?sede=${sedeId}`, { headers });
      this.setState({ subcats: Array.isArray(data) ? data : [] });
    } catch (err) {
      console.log(err);
      this.setState({ error: "No se pudieron obtener las subcategorías." });
    } finally {
      this.setState({ loading: false });
    }
  };

  onCreated = () => {
    this.fetchSubcats();
    this.props.onChanged?.();
  };

  deleteSubcat = async (id) => {
    if (!window.confirm("¿Eliminar esta subcategoría?")) return;
    this.setState({ deletingId: id, error: "" });
    try {
      const headers = getAuthHeaders();
      await axios.delete(`${API_URL_SEDE_SUBCATS}${id}/`, { headers });
      this.setState((prev) => ({ subcats: prev.subcats.filter((s) => s.id !== id) }));
      this.props.onChanged?.();
    } catch (err) {
      console.log(err);
      this.setState({ error: "No se pudo eliminar la subcategoría." });
    } finally {
      this.setState({ deletingId: null });
    }
  };

  render() {
    const { sede } = this.props;
    const sedeId = sede?.pk ?? sede?.id;
    const { open, loading, error, subcats, deletingId } = this.state;

    return (
      <>
        {/* removed disabled prop */}
        <Button color="info" size="sm" onClick={this.toggle}>
          Subcategorías
        </Button>

        <Modal isOpen={open} toggle={this.toggle} size="lg">
          <ModalHeader toggle={this.toggle}>
            Subcategorías — {sede?.sede}
          </ModalHeader>
          <ModalBody>
            {error && <Alert color="danger">{error}</Alert>}

            <h6 className="mb-2">Existentes</h6>
            {loading ? (
              <div className="text-muted mb-3">Cargando…</div>
            ) : subcats.length ? (
              <Table size="sm" bordered responsive className="mb-4">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Código</th>
                    <th>Activa</th>
                    <th style={{ width: 100 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {subcats.map((sc) => (
                    <tr key={sc.id}>
                      <td>{sc.name}</td>
                      <td>{sc.code}</td>
                      <td>{sc.is_active ? "Sí" : "No"}</td>
                      <td>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => this.deleteSubcat(sc.id)}
                          disabled={deletingId === sc.id}
                        >
                          {deletingId === sc.id ? "Eliminando…" : "Eliminar"}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-muted mb-4">No hay subcategorías.</div>
            )}

            <h6 className="mb-2">Agregar nueva</h6>
            <NewSubcategoryForm sedeId={sedeId} onCreated={this.onCreated} />
          </ModalBody>
        </Modal>
      </>
    );
  }
}